import { useMemo } from "react";
import { Tabs } from "react-simple-tabs-component";
import Contact from "./ManagementContact";
import Subdivision from "./ManagementSubdivision";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";

const ManagementCompanyContactForm = () => {


    const tabs = useMemo(() => {
        const result: any[] = [];
        result.push({ label: "Contact", Component: Contact });
        if (hasPermission(["SUBD-V"])) {
            result.push({
                label: "Subdivision",
                Component: Subdivision,
            });
        }
        return result;
    }, []);
    return (
        <div className="mt-5">
            <Tabs tabs={tabs} className="bootstrap-tabs-component" />
        </div>
    );
};

export default ManagementCompanyContactForm;
